import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../../reducers';
import Utils from '../../../../utils';
import { toggleSearchFieldVisibility } from '../actions';
import { DriveItemListSearchButtonContainer, StyledDriveItemListSearchButton } from './styles';
import UserAgentUtils from '../../../../utils/userAgent';
import Tooltip from '../../../../components/Tooltip';


export interface DriveItemListSearchButtonProps {
	dispatch: Dispatch<StoreState>;
}

class DriveItemListSearchButton extends React.Component<DriveItemListSearchButtonProps, {}> {

	constructor(props: DriveItemListSearchButtonProps) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
	}

	render() {
		const tooltipId = Utils.generateId();

		return (
			<DriveItemListSearchButtonContainer>
				<StyledDriveItemListSearchButton onClick={this.handleClick} data-tip={true} data-for={tooltipId}>
					{Utils.getSvgIcon('iconset_search')}
					{UserAgentUtils.isDesktop() && <Tooltip id={tooltipId} text={'messages.search'} />}
				</StyledDriveItemListSearchButton>
			</DriveItemListSearchButtonContainer>
		);
	}

	private handleClick(): void {
		const { dispatch } = this.props;
		dispatch(toggleSearchFieldVisibility());
	}
}

export default connect()(DriveItemListSearchButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Button/index.tsx